module.exports = __webpack_public_path__ + "prod/1.42.2/img/lagou-icon.092e0409.png";